// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1728":"fe7e7a87","2157":"11a6355f","5794":"56b5b332","9745":"fe7e7a87"}[chunkId] + ".chunk.css";
};